<template>
    <div class="tjdw">
        <div class="main" v-loading.fullscreen.lock="loading">
            <div class="radio">
                <el-radio-group v-model="tabPosition"
                                style="margin-bottom: 30px"
                                @change="clear">
                    <el-radio-button label="dw">添加单位</el-radio-button>
                    <el-radio-button label="bm">添加部门</el-radio-button>
                </el-radio-group>
            </div>
            <div class="option">
                <span v-show="tabPosition == 'dw'">单位编码:</span>
                <span v-show="tabPosition == 'bm'">部门编码:</span>
                <div style="width: 60%; margin-left: 40px">
                    <el-input :placeholder="tabPosition == 'dw'?'单位编码':'部门编码'" v-model="code"></el-input>
                </div>
            </div>
            <div class="option">
                <span v-show="tabPosition == 'dw'">单位名称:</span>
                <span v-show="tabPosition == 'bm'">部门名称:</span>
                <div style="width: 60%; margin-left: 40px">
                    <el-input :placeholder="tabPosition == 'dw'?'单位名称':'部门名称'" v-model="name"></el-input>
                </div>
            </div>
            <!-- 部门对应科室,单位对应部门 -->
            <div class="option" v-show="tabPosition == 'dw'">
                所属部门:
                <div style="width: 60%; margin-left: 40px">
                    <el-select v-model="bmId"
                               placeholder="请选择"
                               style="width: 100%">
                        <el-option v-for="item in bmOptions"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="option">
                所属科室:
                <div style="width: 60%; margin-left: 40px">
                    <el-select v-model="parentid"
                               placeholder="请选择"
                               style="width: 100%">
                        <el-option v-for="item in ksOptions"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="button">
                <el-button @click="add">添加单位</el-button><el-button @click="goback">取消</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import { getDivs,divAdd } from '@/api/div.js';
    export default {
        name: "tjdw",
        data() {
            return {
                loading: true,
                ksOptions: [],
                bmOptions: [],
                dwdr: false,
                xzdrwj: false,
                param: "",
                code: "",
                name: "",
                parentid: "",
                bmId: '',
                tabPosition: "dw",
            };
        },
        created() {
            this.init();
        },
        methods: {
            clear(val) {
                this.code = "";
                this.name = "";
                this.parentid = "";
                this.bmId = "";
            },
            goback() {
                this.$router.push({ name: "单位列表" });
            },
            add() {
                if (this.code == "") {
                    this.$message.error(this.tabPosition == 'dw' ? "请输入单位编码!" : '请输入部门编码!');
                } else if (this.name == "") {
                    this.$message.error(this.tabPosition == 'dw' ? "请输入单位名称!" : '请输入部门名称!');
                } else if (this.bmId == "" && this.tabPosition == 'dw') {
                    this.$message.error("请输入所属部门!");
                } else if (this.parentid == "") {
                    this.$message.error("请输入所属科室!");
                } else {
                    this.loading = true;
                    let params = {}
                    if (this.tabPosition == 'dw') {
                        params = {
                            code: this.code,
                            name: this.name,
                            bmId: this.bmId,
                            parentid: this.parentid,
                            type: 0
                        }
                    } else {
                        params = {
                            code: this.code,
                            name: this.name,
                            parentid: this.parentid,
                            type: 2
                        }
                    }
                    divAdd(params)
                        .then((res) => {
                            if (res.status == 0) {
                                this.$message.success("添加成功!");
                                this.code = "";
                                this.name = "";
                                this.parentid = "";
                                this.bmId = '';
                                this.init();
                            }else if(res.status == 1){
                                this.$message.error(res.phrase)
                            }
                            this.loading = false;
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                }
            },
            init() {
                getDivs().then(res => {
                    if (res.status == 0) {
                        this.ksOptions = res.divs.filter((e) => e.type == 1);
                        this.bmOptions = res.divs.filter((e) => e.type == 2);
                    }
                    this.loading = false;
                }).catch(err=>{
                    this.loading = false;
                })
                
            },
        },
    };
</script>
<style scoped>
    .tjdw {
        height: 500px;
        width: 80%;
        margin: 0 auto;
        margin-top: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

        .tjdw .main {
            height: 400px;
            width: 50%;
        }

            .tjdw .main .option {
                height: 80px;
                margin: 10px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                line-height: 55px !important;
                font-size: 20px !important;
                font-weight: 500 !important;
                font-family: fangsong !important;
            }

    .button {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .radio {
        display: flex;
        justify-content: center;
    }
</style>
